export default "__VITE_ASSET__c8aede2d__"